import React from 'react'
import PPVTemplate from 'src/components/page/ppv'
import { promoCodes } from 'src/constants'
import { useCohortFlag } from 'src/modules/hooks/useCohortFlag'
import { WEB_MARKETING_PPV_INTEGRATED_SPORTS } from 'src/modules/reducers/cohorts/constants'
import { commonCtaText, imgixURI } from 'src/modules/utils/constants'

export default (props) => {
  const isIntegratedSportsLive = useCohortFlag(WEB_MARKETING_PPV_INTEGRATED_SPORTS)
  return (
    <PPVTemplate
      lang="en"
      market="us"
      location={props.location}
      title={
        <>
          Badou Jack vs. <span className="desktop-line-break">Noel Mikaelian</span>
        </>
      }
      subtitle={
        <>
          Watch the WBC Cruiserweight Championship live{' '}
          <span className="desktop-line-break">
            this Saturday, Dec. 13, on Pay Per View with Fubo
          </span>
        </>
      }
      poster={imgixURI + 'posters/WBC_PPV_LP_16x9_Static.jpg'}
      posterMobile={imgixURI + 'posters/WBC_PPV_LP_1x1_Static.jpg'}
      ctaText={commonCtaText.getStarted}
      offerCode={promoCodes.ppv_integrated_sports}
      additionalFAQs={additionalFAQs}
      isEventEnded={!isIntegratedSportsLive}
      heroFootnote="Fubo subscription not required"
    />
  )
}

const additionalFAQs = [
  {
    question: 'Can I watch the WBC Cruiserweight Championship on Fubo?',
    answer:
      'Yes, you can watch the WBC Cruiserweight Championship on Fubo Pay Per View. It costs $29.95',
  },
  {
    question: 'What time does Badou Jack vs. Noel Mikaelian fight start on Fubo?',
    answer:
      'The Badou Jack vs. Noel Mikaelian fight is scheduled to start on Fubo at 9 PM ET on December 13, 2025.',
  },
  {
    question: 'How can I find the Badou Jack vs. Noel Mikaelian fight on Fubo?',
    answer:
      'To find the Badou Jack vs. Noel Mikaelian fight on Fubo, simply search Fubo for the event name or “pay per view” on the day of the fight. Or find the Pay Per View channel in the Fubo channel guide.',
  },
  {
    question: 'Will there be live coverage of the WBC Cruiserweight Championship on Fubo?',
    answer:
      'Yes, Fubo will provide live coverage of the WBC Cruiserweight Championship, allowing you to watch the fight as it happens.',
  },
  {
    question:
      'Can I watch commentary and analysis for the Badou Jack vs. Noel Mikaelian fight on Fubo?',
    answer:
      'Yes, Fubo often features commentary and analysis for major boxing events, including the Badou Jack vs. Noel Mikaelian fight. Look for related shows in the sports section.',
  },
  {
    question: 'Is there a way to watch replays of the WBC Cruiserweight Championship on Fubo?',
    answer:
      'Yes, Fubo typically offers replays of major Pay Per View events like the WBC Cruiserweight Championship, so you can catch up on the fight after it airs.',
  },
  {
    question: 'What channels will broadcast the Badou Jack vs. Noel Mikaelian fight on Fubo?',
    answer:
      'The Badou Jack vs. Noel Mikaelian fight will be available on Fubo through designated Pay Per View channels, which you can access on the event date.',
  },
  {
    question:
      'How do I stay updated on boxing events like the WBC Cruiserweight Championship on Fubo?',
    answer:
      'To stay updated on boxing events like the WBC Cruiserweight Championship, check the sports section of Fubo regularly for announcements and upcoming fights.',
  },
]
